import React from 'react';
import PropTypes from 'prop-types';
import Text from '../General/Text';
import {
  ContentWrapperStyled,
  SvgHeaderBlockStyled,
  TextBlockStyled,
  ButtonStyled,
  ButtonDisabledStyled,
  TextBlockRowStyled,
} from './styles/ContactBlockStyled';
import {
  AdvicesText,
  WindowIcon,
  WifiIcon,
  HeadSetIcon,
  WhatsappIcon,
} from '../../images/consejos-bam';
import { redirectToExternalPage } from '../../helpers';
import useWhatsappAvailability from '../../hooks/useWhatsappAvailability';

const ContactBlock = ({ contactData, contactError }) => {
  const whatsappData = useWhatsappAvailability(contactData);
  return (
    <ContentWrapperStyled>
      <SvgHeaderBlockStyled>
        <AdvicesText />
      </SvgHeaderBlockStyled>
      <TextBlockRowStyled>
        <TextBlockStyled>
          <WindowIcon />
          <Text
            size="16px"
            weight="300"
            color="#494C66"
            align="center"
            lineHeight="19px"
            text="Ubica tu Wifi Móvil cerca de una ventana en un espacio seguro, libre de movimiento"
          />
        </TextBlockStyled>
        <TextBlockStyled>
          <WifiIcon />
          <Text
            size="16px"
            weight="300"
            color="#494C66"
            align="center"
            lineHeight="19px"
            text="Si tienes problemas de conexión o tu internet anda lento verifica que tengas datos en MiWOM."
          />
        </TextBlockStyled>
      </TextBlockRowStyled>
      <HeadSetIcon />
      <Text
        size="16px"
        weight="600"
        color="#2D1441"
        align="center"
        lineHeight="20px"
        margin="16px"
        text="Canales de atención"
      />
      <TextBlockRowStyled>
        <ButtonStyled
          onClick={() => {
            redirectToExternalPage('tel:103', true);
          }}
        >
          <span>103</span>
          {` desde tu teléfono WOM`}
        </ButtonStyled>
        <ButtonStyled
          onClick={() => {
            redirectToExternalPage('tel:+56223377600', true);
          }}
        >
          Llámanos al
          <span>+562 2337 7600</span>
        </ButtonStyled>
        {whatsappData && !contactError && whatsappData.enabled && (
          <ButtonStyled
            onClick={whatsappData.click}
            data-testid="enabled-button"
          >
            <WhatsappIcon style={{ marginRight: '5px' }} />
            <span>Whatsapp</span> EJECUTIVO
          </ButtonStyled>
        )}
        {whatsappData && (contactError || !whatsappData.enabled) && (
          <ButtonDisabledStyled data-testid="disabled-button">
            <WhatsappIcon style={{ marginRight: '5px' }} />
            <span>Whatsapp</span> EJECUTIVO
          </ButtonDisabledStyled>
        )}
      </TextBlockRowStyled>
    </ContentWrapperStyled>
  );
};

ContactBlock.propTypes = {
  contactData: PropTypes.shape({
    days: PropTypes.arrayOf(PropTypes.string),
    phoneNumber: PropTypes.string,
    start: PropTypes.string,
    finish: PropTypes.string,
    enabled: PropTypes.bool,
  }),
  contactError: PropTypes.bool.isRequired,
};

ContactBlock.defaultProps = {
  contactData: {
    days: [''],
    phoneNumber: '',
    start: '',
    finish: '',
    enabled: false,
  },
};

export default ContactBlock;
